import React from 'react';

function Home({ onCategorySelect }) {
  const categories = [
    { id: 'animals', name: 'Animals', icon: '🐶', class: 'animals' },
    { id: 'math', name: 'Math', icon: '➕', class: 'math' },
    { id: 'alphabets', name: 'Alphabets', icon: '🔤', class: 'alphabets' },
    { id: 'gk', name: 'General Knowledge', icon: '🌍', class: 'gk' },
    { id: 'colors', name: 'Colors', icon: '🎨', class: 'colors' }
  ];

  return (
    <div className="home-container">
      <h1 className="home-title">🎉 QuizBuddy Kids</h1>
      <p className="home-subtitle">Choose a category to start learning!</p>
      
      <div className="categories-grid">
        {categories.map(category => (
          <button
            key={category.id}
            className={`category-btn ${category.class}`}
            onClick={() => onCategorySelect(category.id)}
          >
            <span className="category-icon">{category.icon}</span>
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Home;
